import { Link } from "react-router-dom";

/**
 * Research 1617 sub-brand mark for the Select-tier header.
 *
 * The source PNG (`/r1617-logo.png`) is tight-cropped to the visible artwork
 * (454×146, ~3.1:1 aspect). On Select-tier pages the header row is grown to
 * h-24 (96px) so the logo can render at h-20 (80px) — dominant vs the 11px
 * nav text with 8px breathing above/below. No negative margins, no bleed.
 */
export default function R1617Mark() {
  return (
    <Link
      to="/shop?tier=select"
      className="inline-flex items-center group"
      data-testid="r1617-wordmark"
      aria-label="Research 1617"
    >
      <img
        src="/r1617-logo.png"
        alt="Research 1617"
        className="h-24 w-auto object-contain transition-opacity group-hover:opacity-90"
        style={{ filter: "brightness(0.72) contrast(1.15) drop-shadow(0 1px 0 rgba(27,22,20,0.15))" }}
        draggable={false}
      />
    </Link>
  );
}
